import { Button } from '@mui/material';
import WarningDialog from './editor/WarningDialog';

interface ChangeChannelDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

function ChangeChannelDialog({ open, onCancel, onConfirm }: ChangeChannelDialogProps) {
  return (
    <WarningDialog
      open={open}
      onClose={onCancel}
      title="Changer de canal"
      message="Attention, changer de canal va supprimer les données de création déjà renseignées pour ce canal. Les offres sont conservées. Voulez-vous continuer ?"
      actions={
        <>
          <Button onClick={onCancel} sx={{ textTransform: 'none', color: 'text.secondary' }}>
            Annuler
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{ textTransform: 'none', fontWeight: 600, backgroundColor: 'error.main', '&:hover': { backgroundColor: 'error.main', opacity: 0.9 } }}
          >
            Changer de canal
          </Button>
        </>
      }
    />
  );
}

export default ChangeChannelDialog;
